/**
 * CUSTOM: Fix für Header-Menü beim Resize
 * Problem: Wenn der Browser vom Mobile-Modus wieder auf Desktop vergrößert wird,
 * bleibt das Menü im Drawer-Modus hängen
 *
 * Diese Datei behebt das Problem, indem sie:
 * 1. Das data-menu-style Attribut überwacht
 * 2. Es korrigiert, wenn es im Desktop-Modus fälschlicherweise auf 'drawer' steht
 * 3. Den Drawer schließt, wenn wir in den Desktop-Modus wechseln
 */

(function() {
  'use strict';

  // Breakpoint aus utilities.js (min-width: 750px)
  const DESKTOP_BREAKPOINT = 750;

  let resizeTimeout = null;
  let mutationObserver = null;
  let isFixing = false; // Flag um Endlosschleifen zu vermeiden

  /**
   * Prüft ob wir ein Touch-Device sind
   */
  function isTouchDevice() {
    return 'ontouchstart' in window && navigator.maxTouchPoints > 0;
  }

  /**
   * Prüft ob wir im Desktop-Modus sein sollten
   */
  function shouldBeDesktopMode() {
    return window.innerWidth >= DESKTOP_BREAKPOINT && !isTouchDevice();
  }

  /**
   * Schließt den geöffneten Header-Drawer
   */
  function closeHeaderDrawer() {
    const headerDrawer = document.querySelector('header-drawer');
    if (headerDrawer && typeof headerDrawer.close === 'function') {
      headerDrawer.close();
    }
  }

  /**
   * Korrigiert das Menü-Style wenn nötig
   */
  function fixMenuStyleIfNeeded() {
    const headerComponent = document.querySelector('#header-component');
    if (!headerComponent || isFixing) return;

    const currentMenuStyle = headerComponent.dataset.menuStyle;

    // Wenn wir im Desktop-Modus sein sollten, aber im Drawer-Modus sind
    if (shouldBeDesktopMode() && currentMenuStyle === 'drawer') {
      isFixing = true;

      // Drawer schließen
      closeHeaderDrawer();

      // Menü-Style auf 'menu' setzen
      headerComponent.dataset.menuStyle = 'menu';

      // Flag nach kurzer Zeit zurücksetzen
      setTimeout(() => {
        isFixing = false;
      }, 100);
    }
  }

  /**
   * Resize Event Handler mit Debouncing
   */
  function handleResize() {
    if (resizeTimeout) {
      clearTimeout(resizeTimeout);
    }

    resizeTimeout = setTimeout(() => {
      fixMenuStyleIfNeeded();
    }, 150);
  }

  /**
   * MutationObserver Callback - überwacht Änderungen am data-menu-style Attribut
   */
  function handleMutation(mutations) {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'data-menu-style') {
        // Nach einer kurzen Verzögerung prüfen und ggf. korrigieren
        setTimeout(() => {
          fixMenuStyleIfNeeded();
        }, 50);
      }
    }
  }

  /**
   * Initialisierung
   */
  function init() {
    const headerComponent = document.querySelector('#header-component');
    if (!headerComponent) {
      console.warn('[Custom Header Fix] Header-Component nicht gefunden');
      return;
    }

    // Resize Event Listener
    window.addEventListener('resize', handleResize);

    // MutationObserver für data-menu-style Attribut
    mutationObserver = new MutationObserver(handleMutation);
    mutationObserver.observe(headerComponent, {
      attributes: true,
      attributeFilter: ['data-menu-style']
    });

    // Initiale Prüfung
    fixMenuStyleIfNeeded();
  }

  /**
   * Cleanup beim Entladen der Seite
   */
  function cleanup() {
    if (resizeTimeout) {
      clearTimeout(resizeTimeout);
    }
    if (mutationObserver) {
      mutationObserver.disconnect();
    }
    window.removeEventListener('resize', handleResize);
  }

  // Initialisierung nach DOM-Load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Cleanup beim Verlassen der Seite
  // 'pagehide' statt 'unload': Chrome blockiert 'unload' inzwischen per Permissions Policy
  // (Konsolen-Violation, Handler lief nicht mehr). 'pagehide' feuert zusätzlich beim
  // Wechsel in den bfcache und ist der offizielle Nachfolger.
  window.addEventListener('pagehide', cleanup);
})();
